import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note48',
  templateUrl: './note48.component.html',
  styleUrls: ['./note48.component.scss'],
})
export class Note48Component implements OnInit {
  note48Form: FormGroup;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}
  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (
        data.noteId === Notes.Note48 &&
        data.response.userInputData !== null &&
        data.response.userInputData !== undefined &&
        data.response.userInputData.data !== null &&
        data.response.userInputData.data !== undefined
      ) {
        this.editNotes48(data.response.userInputData.data);
      }
    });
  }

  editNotes48(res): void {
    this.note48Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
    });
  }

  setForm(): void {
    this.note48Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
